(() => {
  const fonts = ['Anton','Bebas Neue','Oswald','Barlow Condensed','Teko','Rajdhani','Russo One','Orbitron','Audiowide','Black Ops One','Archivo Black','Montserrat','Poppins','Roboto','Lato','Ubuntu','PT Sans','Exo 2','Righteous','Staatliches','Permanent Marker','Lobster','Pacifico','Kaushan Script','Courgette','Dancing Script','Satisfy','Playfair Display','Merriweather','Roboto Slab','Rubik Wet Paint','Allura','Great Vibes','Parisienne','Sacramento','Racing Sans One','Allerta Stencil','Stardos Stencil','UnifrakturMaguntia','Graduate','Pirata One','Alfa Slab One','Bungee','Bowlby One SC','Bangers','Titan One'];
  class CustomTextDecal extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('form');
      this.messages = JSON.parse(this.querySelector('[data-messages]').textContent);
      for (const key of ['text','font','color','width','quantity','confirm','submit','download','status','preview','dimensions','price','font-grid','width-property','height-property','artwork-property']) {
        this[key.replaceAll('-','_')] = this.querySelector(`[data-${key === 'price' ? 'current-decal-price' : key}]`);
      }
      this.font_picker = this.querySelector('.madd-builder__font-browser');
      this.font_summary = this.querySelector('[data-font-summary]');
      this.selected_font = this.querySelector('[data-selected-font]');
      this.font_picker?.addEventListener('keydown', event => {
        if (event.key === 'Escape') { this.font_picker.open = false; this.font_summary?.focus(); }
      });
      this.revision = 0;
      this.busy = false;
      this.fontReady = false;
      this.maxHeight = Number(this.dataset.maxHeight);
      this.fontsChanged = false;
      this.onUploadReady = (event) => {
        const enclosing = event.target instanceof Element ? event.target.closest('form') : null;
        if (enclosing && enclosing !== this.form) return;
        if (typeof event.detail?.uploadFile !== 'function') return;
        this.uploadField = event.detail;
        this.paintStatus();
      };
      window.addEventListener('upload:ready', this.onUploadReady);
      fonts.forEach((font) => {
        const option = document.createElement('option');
        option.value = font;
        option.textContent = font;
        this.font.append(option);
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'madd-builder__font-card';
        button.dataset.fontName = font;
        button.setAttribute('aria-label', this.messages.font_button.replace('{font}', font));
        const name = document.createElement('span');
        name.className = 'madd-builder__font-name';
        name.textContent = font;
        const sample = document.createElement('span');
        sample.className = 'madd-builder__font-sample';
        sample.style.fontFamily = `"${font}"`;
        button.append(name, sample);
        button.addEventListener('click', () => {
          if (this.busy) return;
          this.font.value = font;
          this.changed();
          if (this.font_picker) this.font_picker.open = false;
          this.font_summary?.focus();
        });
        this.font_grid.append(button);
      });
      this.font.value = 'Bebas Neue';
      this.font.addEventListener('change', () => this.changed());
      this.color?.addEventListener('change', () => this.changed());
      this.text.addEventListener('input', () => this.changed());
      this.width.addEventListener('change', () => this.changed());
      this.confirm.addEventListener('change', () => this.paintStatus());
      this.download.addEventListener('click', () => this.downloadArtwork());
      this.form.addEventListener('submit', (event) => this.addToCart(event));
      this.abort = new AbortController();
      this.changed();
    }
    disconnectedCallback() {
      window.removeEventListener('upload:ready', this.onUploadReady);
      this.abort?.abort();
      clearTimeout(this.timer);
    }
    loadFonts() {
      if (document.getElementById('madd-decal-google-fonts')) return;
      const link = document.createElement('link');
      link.id = 'madd-decal-google-fonts';
      link.rel = 'stylesheet';
      link.href = 'https://fonts.googleapis.com/css2?' + fonts.map(font => 'family=' + encodeURIComponent(font).replaceAll('%20','+')).join('&') + '&display=block';
      this.fontStylesheet = new Promise((resolve, reject) => {
        link.addEventListener('load', resolve, {once:true});
        link.addEventListener('error', reject, {once:true});
      });
      document.head.append(link);
    }
    changed() {
      if (this.busy) return;
      this.revision++;
      this.fontReady = false;
      this.metrics = null;
      this.artwork_property.value = '';
      this.confirm.checked = false;
      this.submit.disabled = true;
      this.download.disabled = true;
      if (this.selected_font) {
        this.selected_font.textContent = this.font.value;
        this.selected_font.style.fontFamily = `"${this.font.value}"`;
      }
      this.price.textContent = this.width.selectedOptions[0]?.dataset.decalPrice || '';
      this.font_grid.querySelectorAll('button').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.fontName === this.font.value));
        button.querySelector('.madd-builder__font-sample').textContent = this.text.value.trim() || this.messages.sample;
      });
      this.setStatus(this.messages.loading);
      clearTimeout(this.timer);
      const revision = this.revision;
      this.timer = setTimeout(() => this.render(revision), 160);
    }
    async render(revision) {
      try {
        this.loadFonts();
        if (this.fontStylesheet) await this.fontStylesheet;
        const font = this.font.value;
        const text = this.text.value.trim() || this.messages.sample;
        const faces = await document.fonts.load(`100px "${font}"`, text);
        if (revision !== this.revision) return;
        if (!faces.length) throw new Error('font');
        const scratch = document.createElement('canvas');
        const context = scratch.getContext('2d');
        context.font = `100px "${font}"`;
        const measured = context.measureText(text);
        const width = measured.actualBoundingBoxLeft + measured.actualBoundingBoxRight;
        const height = measured.actualBoundingBoxAscent + measured.actualBoundingBoxDescent;
        if (!(width > 0 && height > 0)) throw new Error('font');
        this.metrics = {width, height, left:measured.actualBoundingBoxLeft, ascent:measured.actualBoundingBoxAscent, text, font};
        this.heightInches = this.widthInches() * height / width;
        this.fontReady = true;
        this.draw(this.preview, 1200, this.color?.selectedOptions[0]?.dataset.previewColor || '#000000');
        this.dimensions.textContent = this.messages.dimensions.replace('{width}', String(this.widthInches())).replace('{height}', this.heightInches.toFixed(2));
        this.width_property.value = `${this.widthInches()} in`;
        this.height_property.value = `${this.heightInches.toFixed(2)} in`;
        this.paintStatus();
      } catch {
        if (revision !== this.revision) return;
        this.metrics = null;
        this.fontReady = false;
        this.preview.getContext('2d').clearRect(0, 0, this.preview.width, this.preview.height);
        this.dimensions.textContent = '';
        this.setStatus(this.messages.font_error, true);
      }
    }
    widthInches() {
      return Number(this.width.selectedOptions[0]?.dataset.width);
    }
    designValid() {
      const width = this.widthInches();
      return this.fontReady && this.text.value.trim().length > 0 && width >= 4 && width <= 30 && width % 2 === 0 && this.heightInches <= this.maxHeight && this.width.selectedOptions[0]?.dataset.available === 'true';
    }
    setStatus(message, error=false) {
      this.status.textContent = message;
      this.status.dataset.error = String(error);
    }
    paintStatus() {
      if (this.busy) return;
      this.download.disabled = !this.designValid();
      this.submit.disabled = !this.designValid() || !this.uploadField || !this.confirm.checked;
      if (!this.fontReady) return;
      if (!this.text.value.trim()) return this.setStatus(this.messages.empty);
      if (this.heightInches > this.maxHeight) return this.setStatus(this.messages.too_tall.replace('{height}', this.heightInches.toFixed(2)), true);
      if (this.width.selectedOptions[0]?.dataset.available !== 'true') return this.setStatus(this.messages.unavailable, true);
      if (!this.uploadField) return this.setStatus(this.messages.upload_missing, true);
      this.setStatus(this.messages.ready);
    }
    draw(canvas, outputWidth, color = '#000000') {
      const m = this.metrics;
      canvas.width = outputWidth;
      const scale = (outputWidth - 4) / m.width;
      canvas.height = Math.ceil(m.height * scale) + 4;
      const ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = color;
      ctx.textBaseline = 'alphabetic';
      ctx.font = `${100 * scale}px "${m.font}"`;
      ctx.fillText(m.text, 2 + m.left * scale, 2 + m.ascent * scale);
    }
    async artworkFile() {
      if (!this.designValid()) throw new Error('invalid');
      const canvas = document.createElement('canvas');
      this.draw(canvas, Math.round(this.widthInches() * 300));
      const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'));
      if (!blob) throw new Error('export');
      const text = this.metrics.text.replace(/[^a-zA-Z0-9_-]/g,'-').slice(0,40) || 'text';
      const font = this.metrics.font.replaceAll(' ','-');
      return new File([blob], `Madd-${text}-${font}-${this.widthInches()}x${this.heightInches.toFixed(2)}in-300ppi.png`, {type:'image/png'});
    }
    async downloadArtwork() {
      this.download.disabled = true;
      try {
        const file = await this.artworkFile();
        const url = URL.createObjectURL(file);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = file.name;
        anchor.click();
        setTimeout(() => URL.revokeObjectURL(url), 1000);
      } catch (error) {
        console.warn('Custom decal could not be saved:', error instanceof Error ? error.message : 'Upload failed');
        this.setStatus(this.messages.failed, true);
      } finally {
        this.download.disabled = !this.designValid();
      }
    }
    async addToCart(event) {
      event.preventDefault();
      if (this.busy || !this.designValid() || !this.confirm.checked || !this.uploadField || !this.form.reportValidity()) return;
      this.busy = true;
      this.setAttribute('aria-busy','true');
      const inputs = [this.text,this.font,this.color,this.width,this.quantity,this.confirm].filter(Boolean);
      inputs.forEach(input => { input.disabled = true; });
      this.submit.disabled = true;
      this.download.disabled = true;
      try {
        this.text.value = this.metrics.text;
        this.setStatus(this.messages.uploading);
        const file = await this.artworkFile();
        const uploaded = await this.uploadField.uploadFile(file);
        const url = uploaded?.url;
        if (typeof url !== 'string' || new URL(url).protocol !== 'https:') throw new Error('upload');
        this.artwork_property.value = url;
        inputs.forEach(input => { input.disabled = false; });
        const data = new FormData(this.form);
        inputs.forEach(input => { input.disabled = true; });
        this.setStatus(this.messages.adding);
        const response = await fetch(this.dataset.cartAddUrl, {method:'POST',body:data,headers:{Accept:'application/json'},signal:this.abort.signal});
        if (!response.ok) {
          const failure = await response.json().catch(() => ({}));
          throw new Error(`Cart ${response.status}: ${failure.description || failure.message || 'Unable to add decal'}`);
        }
        window.location.assign(this.dataset.cartUrl);
      } catch (error) {
        console.warn('Custom decal could not be saved:', error instanceof Error ? error.message : 'Upload failed');
        this.setStatus(this.messages.failed, true);
        this.busy = false;
        this.removeAttribute('aria-busy');
        inputs.forEach(input => { input.disabled = false; });
        this.submit.disabled = !this.designValid() || !this.uploadField || !this.confirm.checked;
        this.download.disabled = !this.designValid();
      }
    }
  }
  if (!customElements.get('custom-text-decal')) customElements.define('custom-text-decal', CustomTextDecal);
})();
